<div class="input-toggle-icon">
  <button
    class="text-link-color input-toggle-icon-button"
    (click)="toggle($event)"
  >
    <i
      *ngIf="control"
      [ngClass]="control?.value ? trueIcon : falseIcon"
      style="font-size: 17px"
      class="fa-thin"
    ></i>
    <p class="text-link-color" *ngIf="falseText && !control?.value">
      {{ falseText }}
    </p>
    <p class="text-link-color" *ngIf="trueText && control?.value">
      {{ trueText }}
    </p>
  </button>
</div>
